<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="공지사항 조회"
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="title" slot-scope="props">
        <span style="border-bottom:1px solid; cursor: pointer" @click.stop.prevent="clickItem(props.item,'update')">{{ props.item.title }}</span>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    mixins: [
      ListMixin
    ],

    data() {
      return {
        modalItem: 0
      }
    },

    created () {
      this.init();
    },

    methods: {
      init () {
        this.initializing('master_notice', 'public/board/notice');
      },
      getDataFromServer() {
        this.getData();
      },
      clickItem(item, kind) {
        if (kind === "update") {
          this.$router.push(this.getPath("master/notice/detail?id=" + item.id));
        }
      },
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>

</style>
